export const project_insight_options = [
    { name: "Portfolio Insights", functionName: "PORTFOLIO_INSIGHTS", type: "PORT_INS" },
    { name: "Project Insights", functionName: "PROJECT_INSIGHTS", type: "PORT_INS" },
    { name: "Portfolio Insights", functionName: "PORTFOLIO_INSIGHTS", type: "TOP_10" }
]

export const agents = [
    { name: "Analyze project data [GI]", type: "projectinsight", code: "structured" },
    { name: "TrafoChat", type: "trafochat", code: "trafochat" },
    { name: "GA GPP Lessons Learned", type: "pggalessonlearned", code: "pgga_lessons_learned" },
]